import type { PageNames } from "../common/types/accessPermissions";

export const getPathNamePermissions = (
	pageNames: PageNames,
	pathname: string,
): string[] | null => {
	for (const page of Object.values(pageNames)) {
		if (page.type === "private" && matchPath(pathname, page.path)) {
			return page.permissionsToAccess || null;
		}
	}
	return null;
};

const matchPath = (pathname: string, pattern: string): boolean => {
	const regexPattern = pattern
		.replace(/:[^/]+/g, "[^/]+") // Replace :param with regex
		.replace(/\//g, "\\/"); // Escape forward slashes

	const regex = new RegExp(`^${regexPattern}$`);
	return regex.test(pathname);
};
